/* eslint-disable @typescript-eslint/naming-convention */
export enum dateFilterTypesEnum {
    none,
    last24Hours,
    today,
    yesterday,
    last3Days,
    thisWeek,
    lastWeek,
    last30Days,
    custom
}
